module.exports = __webpack_public_path__ + "images/emoji/capricorn.c2f599bb4635ad7bea3b.png";